import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const ChannelStore = require('../../stores/channel_store_reflux');
const Globals = require('../../../../app/globals');
import SortableTable2 from '../table/SortableTable2';
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');

const propTypes = {
    className: PropTypes.string,
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {
    className: ''
};

class ChannelShortCourseInstancesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getStateChannel(props.channelId),
            analyticsStoreState: AnalyticsStore.getState(),
            getShortCourseActionId: null,
        };

        this.getCourseInstanceData = this.getCourseInstanceData.bind(this);

        this.unsubscribes = [
            AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        this.getCourseInstanceData(this.props.channelId, this.props.shortCourseId);
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.shortCourseId !== this.props.shortCourseId
            && !this.state.analyticsStoreState.activityAssignments[this.props.shortCourseId]
        ) {
            this.getCourseInstanceData(this.props.channelId, this.props.shortCourseId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getCourseInstanceData(channelId, shortCourseId) {
        const getShortCourseActionId = uuid.v4();
        this.setState({ getShortCourseActionId: getShortCourseActionId }, () => {
            AnalyticsActions.getShortCourseInstanceStatsChannel(
                getShortCourseActionId,
                {
                    shortCourseId: shortCourseId,
                    channelId: channelId
                }
            );
        });
    }

    onChannelStoreChange(state) {
        this.setState({
            channelStoreState: ChannelStore.getStateChannel(this.props.channelId),
        })
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.getShortCourseActionId) {
            additionalState.getShortCourseActionId = null;
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    render() {
        const courseInstances = this.state.analyticsStoreState.shortCourseInstances[this.props.shortCourseId];
        if (!courseInstances) {
            return null;
        }

        let displayColumnCallbacksId = {};
        const currentChannel = this.state.channelStoreState.channel;
        if (!!currentChannel && PermissionsUtil.canAdministerAssignment(currentChannel.user_permissions)) {
            displayColumnCallbacksId.name = (instId) => {
                const courseInstance = courseInstances.find(ci => ci.id === instId);
                switch (courseInstance.integration_type) {
                    case Globals.integration_type.LTI:
                    case Globals.integration_type.LOCAL:
                    case Globals.integration_type.LTI_1_3: {
                        // use an 'a' element instead of Link component to ensure server request is made and Connect/LTI client served
                        return <a href={`/course_instance/${courseInstance.hash}/admin`}>{courseInstance.name}</a>;
                    }
                    default: {
                        return courseInstance.name;
                    }
                }
            }
        }

        return (
            <div className={`${this.props.className}`}>
                <SortableTable2
                    classNameTable="font-size-md"
                    rows={courseInstances}
                    rowsPerPage={100}
                    dateFormat="YYYY-MM-DD"
                    defaultSort={{ key: 'create_date', type: 'date', asc: false }}
                    displayColumnCallbacksId={displayColumnCallbacksId}
                    displayColumnCallbacks={{
                        'student_count': (num) => StringUtil.numberToLocaleString(num),
                        'started_attempt_count': (num) => StringUtil.numberToLocaleString(num),
                        'completed_attempt_count': (num) => StringUtil.numberToLocaleString(num),
                    }}
                    topGroupHeader= {[
                        {
                            displayName: '',
                            colSpan: '3'
                        },
                        {
                            displayName: Strings['en'].analytics.overview.short_course.instance_table.ATTEMPTS,
                            colSpan: '3'
                        },
                        {
                            displayName: Strings['en'].analytics.overview.short_course.instance_table.TIME_PLAYED,
                            colSpan: '2'
                        }
                    ]}
                    columns={[
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.NAME,
                                key: 'name',
                                type: 'string'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.CREATE_DATE,
                                key:'created_at',
                                type: 'date'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.STUDENTS,
                                key: 'student_count',
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.LAST_ATTEMPT,
                                key: 'last_attempt_date',
                                type: 'date'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.STARTED,
                                key: 'started_attempt_count',
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.COMPLETED,
                                key: 'completed_attempt_count',
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.TOTAL_TP,
                                key: 'total_time_played',
                                type: 'duration'
                            },
                            {
                                displayName: Strings['en'].analytics.overview.short_course.instance_table.AVG_TP,
                                key: 'avg_time_played',
                                type: 'duration',
                                width: '10%'
                            }
                        ]}
                />
            </div>
        );
    }
}

ChannelShortCourseInstancesTable.propTypes = propTypes;
ChannelShortCourseInstancesTable.defaultProps = defaultProps;

export default ChannelShortCourseInstancesTable;